
import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from "@/components/ui/accordion";

const FAQ: React.FC = () => {
  const faqs = [
    {
      question: "Por qual motivo escolher a Tax Health?",
      answer: "A Tax Health se destaca por sua abordagem personalizada e focada nas necessidades específicas de profissionais e empresas da área de saúde. Nossa equipe de especialistas compreende as particularidades e desafios únicos enfrentados por médicos, clínicas, laboratórios e hospitais, oferecendo soluções sob medida com processos 100% administrativos."
    },
    {
      question: "A Tax Health atende apenas empresas médico-hospitalares?",
      answer: "Sim, a Tax Health é especializada exclusivamente no atendimento a médicos, clínicas, laboratórios e hospitais. Essa especialização nos permite compreender profundamente as necessidades específicas do setor da saúde e oferecer consultoria tributária altamente personalizada e eficiente."
    },
    {
      question: "Como iniciar a contratação?",
      answer: "Para iniciar o processo, basta entrar em contato conosco através do WhatsApp. Nossa equipe fará uma análise inicial da sua situação tributária e agendará uma reunião para apresentar as oportunidades de redução de impostos específicas para o seu negócio. O processo é simples, rápido e totalmente remoto."
    },
    {
      question: "Como funciona o processo?",
      answer: "Após o contato inicial, nossos especialistas realizam uma análise detalhada da sua documentação fiscal. Identificamos oportunidades de economia e implementamos estratégias 100% administrativas para reduzir sua carga tributária. Também realizamos a restituição de valores pagos incorretamente nos últimos 60 meses. Todo o processo é seguro, legal e sem necessidade de ações judiciais."
    },
    {
      question: "Existe garantia?",
      answer: "Sim. Todas as nossas estratégias são baseadas na legislação fiscal vigente e implementadas através de processos 100% administrativos. Nossa equipe está sempre atualizada em relação às mudanças na legislação tributária, garantindo que você esteja sempre em conformidade com as regras fiscais enquanto maximiza suas economias de forma totalmente legal e segura."
    }
  ];

  return (
    <section className="py-8 md:py-16 px-4 md:px-6 bg-background">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-6 md:mb-12">
          <p className="text-xs tracking-widest font-medium uppercase text-primary mb-2">
            DÚVIDAS FREQUENTES
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            FAQ
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground">
            Tire suas dúvidas sobre as soluções fiscais da TaxHealth
          </p>
        </div>
        
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`} className="border-b border">
              <AccordionTrigger className="text-base md:text-lg font-medium py-5 text-left hover:no-underline min-h-[52px]">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm md:text-base text-muted-foreground pb-3 md:pb-4 pt-1">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
